// extracted by mini-css-extract-plugin
module.exports = {"swiperCard":"swiperCard_swiperCard__Lzp21"};